import type { RouteRecordRaw } from 'vue-router'

export const salesRoute: RouteRecordRaw = {
  name: 'vendas',
  path: 'vendas',
  component: () => import('./pages/SalesPage.vue'),
}
